import React from 'react';
import TextField from 'material-ui/TextField';
import ShortForm from './ShortForm';
import Page from './Page';

export default class ChangePassword extends Page {

	constructor(...args){
		super(...args);
		window.app.resetPasswordForm.username = '';
		window.app.resetPasswordForm.errorMessage = '';
	}

	render(){
		return(
			<ShortForm
				label="CHANGE PASSWORD"
				headerLink={{to:'/change-password-confirmation', label:'ALREADY HAVE A VERIFICATION CODE?'}}
				submitButton={{label:"REQUEST PASSWORD CHANGE", onClick:() => { window.app.resetPasswordForm.submit()}}}
				waiting={window.app.resetPasswordForm.loading}
				errorMessage={window.app.resetPasswordForm.errorMessage}
				>
				<TextField
					label="Email"
					id="username"
					defaultValue={window.app.resetPasswordForm.username}
					onChange={ e => window.app.resetPasswordForm.username = e.currentTarget.value }
					margin="normal"
					fullWidth/>
			</ShortForm>
		);
	}
}





// WEBPACK FOOTER //
// ./src/components/ChangePassword.js